"use strict";
export default function(url, onDataReturned) {
  return {
    _lastUpdatedAt: void 0,
    update: function() {
      return $.ajax({
        url,
        type: "get",
        data: { "since": this._lastUpdatedAt },
        cache: false
      }).then(function(data) {
        var items = onDataReturned(data);
        if (items && items.length > 0) {
          var updated = _.map(_.pluck(items, "updated_at"), function(a) {
            return new Date(a);
          });
          this._lastUpdatedAt = _.max(updated).getTime();
        } else {
          this._lastUpdatedAt = this._lastUpdatedAt || (/* @__PURE__ */ new Date(0)).getTime();
        }
      }.bind(this));
    }
  };
}
